const MINIMUM_COST_OF_MADE_TO_MEASURE_SERVICE = 32; // In pounds
const MINIMUM_LENGTH_OF_FABRIC = 0.7; // In metres

export function calculateMinRollerBlindPrice(
  priceData: string | null | undefined,
) {
  if (!priceData) return "";

  const pricePrefix = priceData.substring(0, 1);
  const priceValue = (
    Math.round(
      Math.ceil(
        100 *
          (MINIMUM_COST_OF_MADE_TO_MEASURE_SERVICE +
            MINIMUM_LENGTH_OF_FABRIC * Number(priceData.substring(1))),
      ),
    ) / 100
  ).toFixed(2);
  return `${pricePrefix}${priceValue}`;
}
